<div *ngIf="mainMenu && mainMenu.length">
    <div class="w-100 d-flex justify-content-center align-items-center">
        <h1 class="ls-h1-page-title text-brand-10 text-start text-sm-center px-3 px-sm-0 mt-4">SiteMap</h1>        
    </div>    
        <div class="container-row">
            <div class="d-flex flex-wrap container ">
                <div class="col-12 col-md-12 ">
                    <div class="marginBottom">
                        <div class="col-12 col-md-9 m-auto mb-5 paragraph">
                            <app-subtree-sitemap [menu]="mainMenu"></app-subtree-sitemap>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>